import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import './index.scss'
import WorkMergeFooter from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergeFooter'
import { WorkMergeSteps } from '@App/stores/search/work/work-merge-bulk-action-store'
import WorkMergePrimarySelection from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergePrimarySelection'
import WorkMergeRequestReview from '@Scenes/RightsholderScene/WorkMerge/WorkMergeSearch/components/WorkMergePanel/WorkMergeRequestReview'

const WorkMergePanel = () => {
    const { catalogSearchBulkActionStore } = useContext(StoresContext)

    const stepComponents: Record<WorkMergeSteps, React.ReactNode> = {
        [WorkMergeSteps.PrimarySelection]: <WorkMergePrimarySelection />,
        [WorkMergeSteps.RequestReview]: <WorkMergeRequestReview />,
    }

    return (
        <div className="work-merge-panel-wrapper">
            {stepComponents[catalogSearchBulkActionStore.currentStep]}
            <WorkMergeFooter />
        </div>
    )
}

export default observer(WorkMergePanel)
